import axios from 'axios';
import config from '@/config';

const api = axios.create({
  baseURL: config.apiUrl,
});

const uri = window.location.href.split('?')[1];
const params = new URLSearchParams(uri);
const api_token = params.get('api_token');

if (api_token) {
  api.interceptors.request.use((conf) => {
    const customConfig = conf;
    customConfig.params = customConfig.params || {};
    customConfig.params.api_token = api_token;
    return customConfig;
  });
}

export default api;
